export const BIOMEDICAL_MODULE_ADMIN = "BIOMEDICAL_MODULE_ADMIN";
export const BIOMEDICAL_DASHBOARD_ANALYSIS_EDITOR =
  "BIOMEDICAL_DASHBOARD_ANALYSIS_EDITOR";
export const BIOMEDICAL_INVENTORY_ADMIN = "BIOMEDICAL_INVENTORY_ADMIN";
export const BIOMEDICAL_INVENTORY_DOWNLOADER =
  "BIOMEDICAL_INVENTORY_DOWNLOADER";
export const BIOMEDICAL_INVENTORY_IMPORTER = "BIOMEDICAL_INVENTORY_IMPORTER";
export const BIOMEDICAL_EQUIPMENT_RESUME_ADMIN =
  "BIOMEDICAL_EQUIPMENT_RESUME_ADMIN";
export const BIOMEDICAL_INSPECTION_ADMIN = "BIOMEDICAL_INSPECTION_ADMIN";
export const BIOMEDICAL_INSPECTION_APPROVER =
  "BIOMEDICAL_INSPECTION_APPROVER";
export const BIOMEDICAL_SERVICE_ORDER_ADMIN =
  "BIOMEDICAL_SERVICE_ORDER_ADMIN";
export const BIOMEDICAL_SERVICE_ORDER_ENGINEER_ASSIGNER =
  "BIOMEDICAL_SERVICE_ORDER_ENGINEER_ASSIGNER";
export const BIOMEDICAL_ENGINEERING_REPORT_ADMIN =
  "BIOMEDICAL_ENGINEERING_REPORT_ADMIN";

export const BIOMEDICAL_INVENTORY_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INVENTORY_ADMIN
];

export const BIOMEDICAL_INVENTORY_DOWNLOAD_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INVENTORY_ADMIN,
  BIOMEDICAL_INVENTORY_DOWNLOADER
];

export const BIOMEDICAL_INVENTORY_IMPORT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INVENTORY_ADMIN,
  BIOMEDICAL_INVENTORY_IMPORTER
];

export const BIOMEDICAL_EQUIPMENT_RESUME_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_EQUIPMENT_RESUME_ADMIN
];

export const BIOMEDICAL_INSPECTION_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INSPECTION_ADMIN
];

export const BIOMEDICAL_INSPECTION_APPROVE_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_INSPECTION_APPROVER
];

export const BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_SERVICE_ORDER_ADMIN
];

export const BIOMEDICAL_SERVICE_ORDER_ASSIGN_ENGINEER_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_SERVICE_ORDER_ADMIN,
  BIOMEDICAL_SERVICE_ORDER_ENGINEER_ASSIGNER
];

export const BIOMEDICAL_ENGINEERING_REPORT_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_ENGINEERING_REPORT_ADMIN
];

export const BIOMEDICAL_DASHBOARD_ANALYSIS_EDIT_ROLES = [
  BIOMEDICAL_MODULE_ADMIN,
  BIOMEDICAL_DASHBOARD_ANALYSIS_EDITOR
];
